import { createApi } from '@reduxjs/toolkit/query/react';
import { FILE_VALIDATION_SERVICE } from 'utils/const';
import { getValidationMsgsByGroup } from './fileValidationApis';

export const fileValidationApi = createApi({
  reducerPath: 'fileValidationApi',
  baseQuery: async (args) => {
    const { path } = args;
    switch (path) {
      case FILE_VALIDATION_SERVICE.PATHS.GET_VALIDATION_MSGS_BY_GROUP:
        return getValidationMsgsByGroup(args);
      default:
        return { error: 'path attribute is missing in the arguments!' };
    }
  },
  endpoints: (builder) => ({
    getValidationMsgsByGroup: builder.query({
      query: (args) => ({
        path: FILE_VALIDATION_SERVICE.PATHS.GET_VALIDATION_MSGS_BY_GROUP,
        ...args,
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetValidationMsgsByGroupQuery } = fileValidationApi;
